import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackOptionsClickEventData } from './legacy-types';
import { useLegacyTrackShownInterest } from './useLegacyTrackShownInterest';
import { mapElasticVehicleToLegacyItem } from './utils';

export const createLegacyTrackOptionsClick = (
  market: Market,
  vehicle: ElasticVehicle,
): LegacyTrackOptionsClickEventData => {
  const eventData: LegacyTrackOptionsClickEventData = {
    eventType: 'microConversion',
    conversionType: 'optionsClick',
    item: mapElasticVehicleToLegacyItem(market, vehicle),
    pageType: 'product page',
  };
  return eventData;
};

export const useLegacyTrackOptionsClick = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();
  const { trackLegacyShownInterest } = useLegacyTrackShownInterest();

  const trackLegacyOptionsClick = useCallback(
    (vehicle: ElasticVehicle) => {
      trackLegacyShownInterest(vehicle);
      track({
        event: 'microConversion',
        data: createLegacyTrackOptionsClick(market, vehicle),
      });
    },
    [market, track],
  );

  return {
    trackLegacyOptionsClick,
  };
};
